// FAQ Data for PAK School & College System

export const FAQ_DATA = [
  {
    question: "What is PAK School & College System's mission?",
    answer: "Our mission is to give quality education with major emphasis on character building, applied knowledge and skills, enabling the students to successfully enter the professional colleges, with sound educational background."
  },
  {
    question: "What is the school's vision?",
    answer: "Our vision is 'Every Student A Star' - to empower every student to shine brilliantly like a star, fostering their unique talents and potential."
  },
  {
    question: "What grade levels does PAK School & College System offer?",
    answer: "We offer education from Nursery to College level, including Play Group, Nursery, KG, Grade 1-8, and higher secondary education."
  },
  {
    question: "What are the core values of PAK School & College System?",
    answer: "Our core values include honesty, hard work, respect for others, cleanliness, unconditional love and kindness, justice, forgiveness, thankfulness, compassion, tolerance, and cooperation."
  },
  {
    question: "How can I apply for admission?",
    answer: "You can apply for admission by visiting our school campus, contacting our admission office, or visiting our website's admission page for detailed information about the admission process."
  },
  {
    question: "What makes PAK School & College System different?",
    answer: "We offer a holistic approach to education with innovation in teaching, student-centric approach, global perspective, character development, and strong community engagement."
  },
  {
    question: "Does the school provide transportation?",
    answer: "Please contact our school office for detailed information about transportation services and routes available in your area."
  },
  {
    question: "What extracurricular activities are available?",
    answer: "We offer various extracurricular activities including sports, arts, music, debate, and other clubs to ensure well-rounded development of our students."
  },
  {
    question: "How can parents stay updated about their child's progress?",
    answer: "Parents can stay updated through regular parent-teacher meetings, progress reports, school portal, and direct communication with teachers and administration."
  },
  {
    question: "What is the school's approach to character building?",
    answer: "Character development is woven into the fabric of our educational philosophy through our core values, community service programs, and emphasis on moral and ethical development."
  }
];

// Generate FAQ structured data
export const getFAQStructuredData = () => {
  return {
    "@context": "https://schema.org",
    "@type": "FAQPage",
    "mainEntity": FAQ_DATA.map(faq => ({
      "@type": "Question",
      "name": faq.question,
      "acceptedAnswer": {
        "@type": "Answer",
        "text": faq.answer
      }
    }))
  };
};
